
import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import CottageRoundedIcon from '@mui/icons-material/CottageRounded';

interface TipoPgStackComponentProps {
  objectWithValues: any[]
}

const TipoPgStackComponent: FunctionComponent<TipoPgStackComponentProps> = ({ objectWithValues }) => {

  return ( <>
    <StackComponent
      icon={<CottageRoundedIcon/>}
      title="Tipos Pgs"
      total={`${objectWithValues?.length}`}
      valueActual={'Novos 0'}
    />
  </> );
}

export default TipoPgStackComponent;
